<template>
  <div class="solution">
    <el-container >
      <!--左侧侧边栏-->
      <el-aside style="width:200px;">
        <el-menu
          :default-active="1-1"
          :active="1-1"
          :default-openeds="openeds"
          router="true"
          class="el-menu-vertical-demo">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>智慧物联</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1" route="/solution/envMonitor">生态环境监测</el-menu-item>
              <el-menu-item index="1-2" route="/solution/riverMonitor">河湖水质监测</el-menu-item>
              <el-menu-item index="1-3" route="/solution/farmMonitor">农业生态监测</el-menu-item>
              <el-menu-item index="1-4" route="/solution/industryMonitor">生产物联监测</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>防伪溯源</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-1" route="/solution/seedTrace">农资防伪溯源</el-menu-item>
              <el-menu-item index="2-2" route="/solution/foodTrace">食品防伪溯源</el-menu-item>
              <el-menu-item index="2-3" route="/solution/drinkTrace">饮品防伪溯源</el-menu-item>
              <el-menu-item index="2-4" route="/solution/materialTrace">原料防伪溯源</el-menu-item>
              <el-menu-item index="2-5" route="/solution/otherTrace">其他防伪溯源</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>智慧社区</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="3-1" route="/solution/idleAsset">闲置资源服务</el-menu-item>
              <el-menu-item index="3-2" route="/solution/houseKeep">社区家政服务</el-menu-item>
              <el-menu-item index="3-3" route="/solution/delivery">社区配送服务</el-menu-item>
              <el-menu-item index="3-4" route="/solution/helpEach">社区互助服务</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!--主要区域容器-->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  data () {
    return {
      openeds: ['1', '2', '3', '4'],
      uniqueOpened: false
    }
  }
}
</script>

<style lang="less" scoped>
.el-aside {
  border: 1px;
  border-left:grey
}
</style>
